(function(){
  'use strict';

  document.querySelectorAll('script[data-section-id]').forEach(initSection);

  function initSection(scriptEl){
    const sectionId = scriptEl.getAttribute('data-section-id');
    const root = document.getElementById('ss-root-' + sectionId);
    if (!root || root.dataset.ssInit) return;
    root.dataset.ssInit = '1';

    const dataEl = document.getElementById('ss-product-data-' + sectionId);
    let productData = { variants: [] };
    try { productData = JSON.parse(dataEl.textContent); } catch(e){ /* leave empty */ }

    const imagesEl = document.getElementById('ss-material-images-' + sectionId);
    let materialImages = {};
    let materialImagesReady = Promise.resolve();
    if (imagesEl){
      try {
        const raw = JSON.parse(imagesEl.textContent);
        const checks = Object.keys(raw).map(key=>{
          return new Promise(resolve=>{
            const img = new Image();
            const done = (ok)=>{ if (ok) materialImages[key] = raw[key]; resolve(); };
            img.onload = ()=>done(true);
            img.onerror = ()=>done(false);
            img.src = raw[key];
            setTimeout(()=>done(false), 4000); // don't hang forever on a slow/missing file
          });
        });
        materialImagesReady = Promise.all(checks);
      } catch(e){ /* falls back to procedural fills */ }
    }

    // uploaded icon images (e.g. from Canva) — same load-check + fallback
    // pattern as the material photos: if a key is missing or the file 404s,
    // that icon just falls back to the drawn version in iconPath() below.
    const iconImagesEl = document.getElementById('ss-icon-images-' + sectionId);
    let iconImages = {};
    let iconImagesReady = Promise.resolve();
    if (iconImagesEl){
      try {
        const raw = JSON.parse(iconImagesEl.textContent);
        const checks = Object.keys(raw).map(key=>{
          return new Promise(resolve=>{
            const img = new Image();
            const done = (ok)=>{ if (ok) iconImages[key] = raw[key]; resolve(); };
            img.onload = ()=>done(true);
            img.onerror = ()=>done(false);
            img.src = raw[key];
            setTimeout(()=>done(false), 4000);
          });
        });
        iconImagesReady = Promise.all(checks);
      } catch(e){ /* falls back to drawn icons */ }
    }

    // ---- config (Room Number signs only) ----
    const SHAPES = {
      rectangle: { label:'Rectangle' },
      oval:      { label:'Oval' },
      circle:    { label:'Circle' },
      arch:      { label:'Arch' },
      wavy:      { label:'Wavy' },
      bowed:     { label:'Bowed Edge' },
      diagonal:  { label:'Diagonal Cut' }
    };
    // Decorative treatments layered on top of whatever Shape is selected — modeled
    // after design capabilities (side stripes, offset shadows, two-tone splits,
    // banner graphics) rather than any one franchise's specific sign, and with no
    // logos — these are meant for independent hotels ordering their own design.
    const ACCENTS = {
      none:   { label:'None', needsColor:false },
      stripe: { label:'Side Stripe',        needsColor:true, incompatibleShapes:['circle','oval'] },
      bands:  { label:'Top & Bottom Bands', needsColor:true, incompatibleShapes:['circle','oval'] },
      shadow: { label:'Offset Shadow',      needsColor:true },
      split:  { label:'Two-Tone Split',     needsColor:true },
      banner: { label:'Banner Swoosh',      needsColor:true }
    };
    const ACCENT_COLORS = {
      charcoal: { label:'Charcoal', hex:'#2B2E33' },
      red:      { label:'Red',      hex:'#8C2F2A' },
      brass:    { label:'Brass',    hex:'#C6A05F' },
      sage:     { label:'Sage',     hex:'#6B7A5E' },
      custom:   { label:'Custom',   hex:null }
    };
    const MATERIALS = {
      standard:  { label:'1/8" Acrylic/Rowmark',              engrave:'#241D0F' },
      backplate: { label:'1/8" Acrylic/Rowmark + Backplate',  engrave:'#241D0F' }
    };
    const TYPEFACES = {
      serif: { label:'Classic Serif', family:"Georgia, 'Times New Roman', serif", weight:600 },
      sans:  { label:'Modern Sans',   family:"-apple-system, Helvetica, Arial, sans-serif", weight:700 },
      script:{ label:'Script',        family:"'Snell Roundhand', 'Brush Script MT', 'Segoe Script', cursive", weight:400, italic:false }
    };
    const SIZES = {
      small:  { label:'Small',  w:6,  h:4 },
      medium: { label:'Medium', w:8,  h:5 },
      large:  { label:'Large',  w:10, h:6 }
    };
    const MOUNTINGS = {
      flush:    { label:'Flush Wall-Mount' },
      standoff: { label:'Standoff Mount' }
    };
    const ICONS = {
      none:      { label:'None' },
      access:    { label:'Handicap' },
      audio:     { label:'Audio Accessible' },
      nosmoking: { label:'No Smoking' }
    };


    let state = {
      mode: 'single', // 'single' | 'bulk'
      roomText:'204', roomSub:'',
      shape:'rectangle', material:'standard', typeface:'sans',
      size:'medium', mounting:'flush', icons:[],
      plateColor:'#2B2E33', textColor:'#F2ECDE', textColorManual:true,
      accent:'none', accentColor:'charcoal', accentCustomColor:'#8C2F2A',
      // ---- bulk order (hotels ordering many rooms at once) ----
      // Style (shape/material/color/typeface/size/mounting/accent) is always
      // shared across the whole batch — only the room number, sub-label, and
      // icons vary per sign, since that's the only thing that differs between
      // rooms in practice.
      rooms: [],
      activeRoomIndex: 0
    };

    // Whichever room's text/sub-label/icons should currently render in the
    // live preview — the single-sign fields in single mode, or the room
    // that's focused/selected in the bulk rooms table.
    function getActiveRoom(){
      if (state.mode === 'bulk'){
        return state.rooms[state.activeRoomIndex] || { roomText:'', roomSub:'', icons:[] };
      }
      return { roomText: state.roomText, roomSub: state.roomSub, icons: state.icons };
    }

    // ---- variant lookup: Option1=Size, Option2=Material, Option3=Mounting ----
    const variantMap = {};
    productData.variants.forEach(v=>{
      variantMap[v.size + '|' + v.material + '|' + v.mounting] = v;
    });

    function findVariant(){
      const key = SIZES[state.size].label + '|' + MATERIALS[state.material].label + '|' + MOUNTINGS[state.mounting].label;
      return variantMap[key] || null;
    }

    function escapeXml(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    function iconPath(id, color){
      const stroke = `stroke="${color}" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"`;
      switch(id){
        case 'access': return `<g transform="scale(0.08)"><path d="M 173.101562 109.238281 C 189.375 107.734375 202.019531 93.714844 202.019531 77.316406 C 202.019531 59.667969 187.617188 45.269531 169.972656 45.269531 C 152.324219 45.269531 137.925781 59.667969 137.925781 77.316406 C 137.925781 82.699219 139.425781 88.207031 141.929688 92.839844 L 153.347656 253.511719 L 270.953125 253.546875 L 319.1875 366.566406 L 382.515625 341.730469 L 372.710938 318.378906 L 337.269531 331.171875 L 290.597656 223.425781 L 181.253906 224.160156 L 179.753906 203.8125 L 258.90625 203.84375 L 258.90625 173.738281 L 176.734375 173.703125 L 173.105469 109.234375 Z" fill="${color}"/><path d="M 291.375 339.664062 C 271.527344 378.898438 229.984375 404.75 185.671875 404.75 C 120.585938 404.75 67.5 351.664062 67.5 286.578125 C 67.5 240.878906 95.195312 198.414062 136.523438 179.589844 L 139.199219 214.488281 C 114.753906 229.894531 99.683594 257.6875 99.683594 286.820312 C 99.683594 334.035156 138.195312 372.542969 185.410156 372.542969 C 228.605469 372.542969 265.4375 339.394531 270.464844 296.863281 L 291.378906 339.660156 Z" fill="${color}"/></g>`;
        case 'audio': return `<g transform="scale(0.049150)"><g transform="translate(-33.552374,765.800857) scale(0.100000,-0.100000)"
fill="${color}" stroke="none">
<path d="M6235 7647 c-140 -46 -235 -176 -235 -320 0 -84 30 -144 133 -270
212 -260 355 -482 491 -762 286 -585 413 -1203 373 -1810 -17 -269 -15 -320
18 -394 32 -71 96 -135 170 -171 138 -67 329 3 407 147 34 63 45 123 59 323
23 326 0 748 -60 1080 -130 716 -450 1397 -934 1990 -85 104 -118 134 -182
167 -60 31 -176 41 -240 20z"/>
<path d="M3085 6990 c-139 -17 -269 -42 -373 -71 -388 -109 -731 -309 -1013
-589 -298 -297 -496 -630 -614 -1035 -44 -150 -23 -254 71 -355 65 -69 139
-103 229 -104 105 -1 167 24 241 98 60 60 62 63 108 206 89 278 215 489 411
686 252 253 523 405 850 475 156 33 431 38 594 10 343 -58 648 -218 901 -471
153 -153 239 -271 330 -455 124 -252 165 -427 165 -710 -1 -214 -13 -296 -72
-480 -148 -463 -468 -834 -888 -1030 -219 -103 -264 -126 -355 -186 -123 -81
-324 -281 -402 -399 -175 -265 -249 -495 -267 -835 -6 -93 -17 -197 -26 -229
-59 -222 -233 -404 -460 -482 -67 -23 -97 -28 -185 -28 -166 0 -292 44 -427
150 -102 80 -139 98 -203 98 -74 -1 -146 -39 -233 -122 -88 -86 -122 -153
-121 -242 1 -118 48 -185 212 -303 195 -140 428 -224 685 -247 254 -22 524 46
764 193 287 175 487 426 588 739 45 139 62 240 70 418 7 168 25 267 66 364 58
136 168 270 285 347 34 21 125 68 203 103 332 151 505 268 747 510 320 319
523 674 628 1096 135 539 78 1074 -168 1575 -165 335 -404 625 -698 845 -319
239 -653 379 -1064 445 -115 19 -474 28 -579 15z"/>
<path d="M5565 6907 c-96 -32 -163 -91 -204 -177 -22 -46 -26 -69 -26 -140 0
-107 16 -141 119 -270 242 -300 390 -599 490 -996 56 -219 68 -328 75 -664 6
-303 7 -317 29 -358 35 -67 98 -129 161 -159 48 -24 68 -28 141 -28 74 0 92 4
143 30 73 37 139 108 168 183 20 51 23 81 27 275 7 318 -19 555 -94 858 -117
479 -364 979 -654 1328 -68 82 -151 123 -258 128 -46 2 -93 -3 -117 -10z"/>
<path d="M3025 5904 c-203 -36 -374 -105 -547 -220 -106 -71 -135 -106 -164
-205 -35 -116 0 -272 79 -351 80 -80 236 -111 348 -69 31 12 80 40 110 62 69
53 197 113 274 130 136 29 324 5 442 -55 66 -33 158 -107 210 -169 195 -232
204 -588 19 -830 -74 -97 -102 -192 -86 -289 20 -121 65 -185 169 -236 68 -33
83 -37 155 -37 95 0 145 14 207 54 120 80 275 383 325 638 24 119 24 375 1
492 -37 182 -105 349 -202 496 -214 323 -559 541 -939 594 -105 15 -303 12
-401 -5z"/>
<path d="M3257 4990 c-104 -27 -179 -89 -226 -190 -37 -78 -37 -191 0 -270 78
-167 272 -241 434 -167 78 36 137 95 170 170 73 162 0 360 -160 433 -60 28
-159 38 -218 24z"/>
<path d="M2570 4317 c-57 -17 -141 -79 -177 -131 -97 -141 -69 -336 65 -441
69 -55 126 -75 208 -75 262 0 422 295 279 512 -36 53 -118 115 -177 133 -58
17 -146 18 -198 2z"/>
<path d="M1553 3979 c-71 -27 -155 -106 -190 -177 -23 -47 -28 -70 -28 -132 0
-139 8 -149 437 -577 435 -433 429 -428 576 -421 103 5 133 19 213 95 76 72
103 133 103 233 0 133 4 127 -437 567 -365 364 -396 392 -450 412 -73 27 -155
27 -224 0z"/>
<path d="M1257 2990 c-104 -27 -179 -89 -226 -190 -37 -78 -37 -191 0 -270 78
-167 272 -241 434 -167 78 36 137 95 170 170 73 162 0 360 -160 433 -60 28
-159 38 -218 24z"/>
<path d="M570 2317 c-57 -17 -141 -79 -177 -131 -97 -141 -69 -336 65 -441 69
-55 126 -75 208 -75 262 0 422 295 279 512 -36 53 -118 115 -177 133 -58 17
-146 18 -198 2z"/>
</g></g>`;
        case 'nosmoking': return `<g transform="scale(0.043760)"><g transform="translate(-2.171468,825.530283) scale(0.100000,-0.100000)"
fill="${color}" stroke="none">
<path d="M3795 8250 c-727 -55 -1490 -333 -2090 -764 -255 -183 -635 -542
-816 -771 -506 -639 -799 -1403 -860 -2240 -15 -206 -6 -688 16 -845 176
-1288 878 -2374 1954 -3025 888 -537 1947 -718 2967 -506 621 128 1141 363
1653 746 617 461 1074 1083 1361 1853 200 534 297 1171 261 1706 -59 875 -360
1665 -887 2326 -141 176 -472 508 -644 645 -600 477 -1361 785 -2135 866 -137
14 -633 20 -780 9z m614 -631 c500 -48 889 -159 1296 -368 354 -182 595 -354
869 -621 508 -495 834 -1107 980 -1840 44 -220 56 -348 56 -596 0 -618 -120
-1126 -383 -1624 -80 -153 -164 -293 -246 -409 -107 -155 -135 -191 -148 -188
-7 1 -329 317 -716 702 -2578 2567 -4032 4011 -4048 4023 -34 24 -128 142
-123 155 7 19 133 114 259 194 534 341 981 500 1595 567 157 17 457 19 609 5z
m-2203 -1948 c1865 -1852 4169 -4158 4169 -4173 0 -21 -154 -142 -315 -250
-267 -177 -518 -300 -821 -402 -634 -213 -1293 -243 -1934 -86 -274 67 -481
143 -727 266 -683 342 -1216 879 -1563 1573 -346 694 -449 1515 -284 2271 54
244 104 404 202 640 115 277 216 444 502 831 17 24 36 39 46 37 9 -2 336 -320
725 -707z"/>
<path d="M3745 7038 c-79 -28 -107 -89 -160 -353 -33 -158 -43 -364 -26 -485
35 -235 172 -496 332 -631 144 -121 262 -176 461 -215 49 -9 94 -22 102 -28 8
-6 26 -51 41 -101 33 -111 80 -214 132 -291 97 -143 293 -285 488 -353 l100
-35 325 -7 c206 -4 340 -11 365 -19 23 -7 57 -30 81 -55 52 -53 64 -103 64
-255 0 -98 2 -110 19 -120 11 -5 73 -10 139 -10 167 0 168 0 165 155 -3 202
-49 323 -167 440 -40 39 -98 84 -131 102 -120 63 -133 65 -455 69 -339 5 -393
13 -520 75 -145 72 -265 212 -310 364 -6 22 -15 90 -20 150 -9 124 -20 157
-59 175 -14 7 -84 16 -156 21 -71 5 -165 17 -208 28 -234 61 -398 233 -466
494 -44 167 -38 310 25 602 41 193 43 239 12 259 -17 11 -138 41 -142 35 -1 0
-14 -5 -31 -11z"/>
<path d="M4559 6609 c-19 -19 -21 -30 -18 -134 3 -75 8 -117 18 -128 11 -14
33 -17 120 -17 285 0 451 -51 575 -176 92 -94 126 -171 126 -288 0 -100 -23
-177 -80 -273 -28 -45 -50 -91 -50 -101 0 -24 46 -87 93 -129 45 -39 94 -48
231 -39 131 8 335 -8 406 -32 176 -61 344 -186 436 -323 106 -160 125 -240
133 -581 8 -316 2 -301 114 -306 83 -4 149 10 178 39 18 18 19 34 19 227 0
224 -12 327 -57 482 -75 262 -256 503 -474 634 -186 110 -335 156 -536 163
-79 3 -143 8 -143 10 0 3 7 33 17 67 22 81 22 241 0 325 -36 136 -136 289
-251 383 -194 159 -378 217 -693 218 -132 0 -145 -2 -164 -21z"/>
<path d="M5103 3954 c-7 -19 56 -88 227 -249 41 -38 163 -155 270 -260 273
-266 349 -332 361 -314 14 23 12 812 -3 827 -9 9 -118 12 -430 12 -372 0 -419
-2 -425 -16z"/>
<path d="M6130 3900 c-19 -19 -20 -33 -20 -422 0 -222 4 -409 8 -416 7 -9 45
-12 158 -10 l149 3 3 407 c1 249 -2 416 -8 432 l-10 26 -130 0 c-117 0 -132
-2 -150 -20z"/>
<path d="M6590 3901 c-6 -13 -10 -165 -10 -425 0 -390 1 -406 19 -416 33 -17
243 -13 269 6 l22 15 0 386 0 385 -34 34 -34 34 -111 0 c-99 0 -111 -2 -121
-19z"/>
<path d="M1501 3960 c-69 -17 -66 5 -69 -465 -3 -417 -2 -425 18 -445 l20 -20
1505 2 c1196 2 1507 6 1517 16 10 10 -4 29 -72 98 -47 47 -139 136 -205 197
-103 95 -205 191 -565 534 -36 34 -79 68 -95 75 -24 10 -229 13 -1025 15 -547
1 -1010 -2 -1029 -7z"/>
</g></g>`;
        default: return '';
      }
    }

    // ---- grade-1 braille transliteration (real dots, not decorative) ----
    // Standard 6-dot cell numbering:  1 4
    //                                 2 5
    //                                 3 6
    const BRAILLE_LETTERS = {
      a:[1], b:[1,2], c:[1,4], d:[1,4,5], e:[1,5], f:[1,2,4], g:[1,2,4,5], h:[1,2,5], i:[2,4], j:[2,4,5],
      k:[1,3], l:[1,2,3], m:[1,3,4], n:[1,3,4,5], o:[1,3,5], p:[1,2,3,4], q:[1,2,3,4,5], r:[1,2,3,5], s:[2,3,4], t:[2,3,4,5],
      u:[1,3,6], v:[1,2,3,6], w:[2,4,5,6], x:[1,3,4,6], y:[1,3,4,5,6], z:[1,3,5,6]
    };
    const BRAILLE_DIGIT_LETTER = {'1':'a','2':'b','3':'c','4':'d','5':'e','6':'f','7':'g','8':'h','9':'i','0':'j'};
    const BRAILLE_NUMBER_SIGN = [3,4,5,6];

    // digits get the number-sign cell once per run, then a/b/c... stand in for 1/2/3...;
    // letters map directly; anything else (space, punctuation) becomes a blank cell
    function textToBrailleCells(text){
      const cells = [];
      let numberMode = false;
      for (const ch of String(text||'')){
        if (/[0-9]/.test(ch)){
          if (!numberMode){ cells.push(BRAILLE_NUMBER_SIGN); numberMode = true; }
          cells.push(BRAILLE_LETTERS[BRAILLE_DIGIT_LETTER[ch]]);
        } else if (/[a-zA-Z]/.test(ch)){
          numberMode = false;
          cells.push(BRAILLE_LETTERS[ch.toLowerCase()] || []);
        } else {
          numberMode = false;
          cells.push([]);
        }
      }
      return cells;
    }
    function brailleMarkup(text, cx, cy, color, dotR, dotGap, cellGap){
      const cells = textToBrailleCells(text);
      if (!cells.length) return '';
      const cellWidth = dotGap + cellGap;
      const totalWidth = cells.length*cellWidth - cellGap;
      const positions = { 1:[0,0], 2:[0,1], 3:[0,2], 4:[1,0], 5:[1,1], 6:[1,2] };
      let x = cx - totalWidth/2, out = '';
      cells.forEach(dotsInCell=>{
        dotsInCell.forEach(d=>{
          const [col,row] = positions[d];
          out += `<circle cx="${x+col*dotGap}" cy="${cy+row*dotGap}" r="${dotR}" fill="${color}"/>`;
        });
        x += cellWidth;
      });
      return out;
    }

    // ---- WCAG contrast ratio — a practical, checkable proxy for ADA's
    // qualitative "high contrast, non-glare finish" requirement (ADA itself
    // doesn't cite this exact formula, but it's a reasonable stand-in) ----
    function hexToRgb(hex){
      hex = String(hex).replace('#','');
      if (hex.length===3) hex = hex.split('').map(c=>c+c).join('');
      const num = parseInt(hex,16);
      return [(num>>16)&255, (num>>8)&255, num&255];
    }
    function relLuminance(hex){
      const [r,g,b] = hexToRgb(hex).map(v=>{
        v/=255;
        return v<=0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055,2.4);
      });
      return 0.2126*r+0.7152*g+0.0722*b;
    }
    function contrastRatio(hex1,hex2){
      const L1=relLuminance(hex1), L2=relLuminance(hex2);
      const lighter=Math.max(L1,L2), darker=Math.min(L1,L2);
      return (lighter+0.05)/(darker+0.05);
    }

    function archPathD(x,y,w,h){
      const topY = y + h*0.24;
      return `M ${x} ${y+h} L ${x} ${topY} A ${w/2} ${topY-y} 0 0 1 ${x+w} ${topY} L ${x+w} ${y+h} Z`;
    }
    function wavyPathD(x,y,w,h){
      const iw = w*0.06;
      return `M ${x+iw} ${y} L ${x+w-iw} ${y} C ${x+w-iw*2.4} ${y+h*0.3}, ${x+w-iw*2.4} ${y+h*0.7}, ${x+w-iw} ${y+h} L ${x+iw} ${y+h} C ${x+iw*2.4} ${y+h*0.7}, ${x+iw*2.4} ${y+h*0.3}, ${x+iw} ${y} Z`;
    }
    function diagonalPathD(x,y,w,h){
      const cut = Math.min(w,h)*0.22;
      return `M ${x} ${y} L ${x+w-cut} ${y} L ${x+w} ${y+cut} L ${x+w} ${y+h} L ${x} ${y+h} Z`;
    }
    function bowedPathD(x,y,w,h){
      // straight on three sides, left edge bows outward in a gentle convex curve
      const b = w*0.09;
      return `M ${x+b} ${y} Q ${x-w*0.05} ${y+h/2} ${x+b} ${y+h} L ${x+w} ${y+h} L ${x+w} ${y} Z`;
    }
    function shapeMarkup(shape, x, y, w, h, attrs, rx){
      rx = (rx===undefined) ? 6 : rx;
      switch(shape){
        case 'oval': return `<ellipse cx="${x+w/2}" cy="${y+h/2}" rx="${w/2}" ry="${h/2}" ${attrs}/>`;
        case 'circle': { const r=Math.min(w,h)/2; return `<ellipse cx="${x+w/2}" cy="${y+h/2}" rx="${r}" ry="${r}" ${attrs}/>`; }
        case 'arch': return `<path d="${archPathD(x,y,w,h)}" ${attrs}/>`;
        case 'wavy': return `<path d="${wavyPathD(x,y,w,h)}" ${attrs}/>`;
        case 'bowed': return `<path d="${bowedPathD(x,y,w,h)}" ${attrs}/>`;
        case 'diagonal': return `<path d="${diagonalPathD(x,y,w,h)}" ${attrs}/>`;
        default: return `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${rx}" ${attrs}/>`;
      }
    }
    function standoffPoints(shape, x, y, w, h){
      if (shape==='circle' || shape==='oval'){
        const rx = (shape==='circle') ? Math.min(w,h)/2 : w/2;
        const ry = (shape==='circle') ? Math.min(w,h)/2 : h/2;
        const cx = x+w/2, cy = y+h/2, k = 0.78;
        return [45,135,225,315].map(deg=>{
          const rad = deg*Math.PI/180;
          return [cx + rx*k*Math.cos(rad), cy + ry*k*Math.sin(rad)];
        });
      }
      const inset = (shape==='rectangle') ? 18 : Math.max(w,h)*0.09;
      if (shape==='arch'){
        // Top of the plate is cut away by the arc except at the very center
        // (see archPathD) — the flat vertical sides don't start until topY,
        // so top standoffs need to sit at/below that line, not at a generic
        // top-corner inset (which landed in the cut-away area above the arc).
        const topY = y + h*0.24;
        return [[x+inset, topY+inset], [x+w-inset, topY+inset], [x+inset, y+h-inset], [x+w-inset, y+h-inset]];
      }
      if (shape==='diagonal'){
        // Top-right corner is sliced off by a diagonal cut (see diagonalPathD)
        // — shift that standoff left, off the missing corner and onto the
        // sign's actual top edge.
        const cut = Math.min(w,h)*0.22;
        return [[x+inset, y+inset], [x+w-cut-inset, y+inset], [x+inset, y+h-inset], [x+w-inset, y+h-inset]];
      }
      if (shape==='bowed'){
        // Left edge bows outward from x+b rather than running straight down
        // x (see bowedPathD) — left standoffs need to start from that bowed
        // edge, not from the plain rectangle inset (which sat left of the
        // actual plate edge, off the sign).
        const b = w*0.09;
        const leftX = x + b + inset*0.5;
        return [[leftX, y+inset], [x+w-inset, y+inset], [leftX, y+h-inset], [x+w-inset, y+h-inset]];
      }
      return [[x+inset,y+inset],[x+w-inset,y+inset],[x+inset,y+h-inset],[x+w-inset,y+h-inset]];
    }
    // ---- accent style overlays (drawn on top of / behind the base plate) ----
    function accentColorHex(){
      return state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].hex;
    }
    function offsetShadowMarkup(shape, px, py, w, h, color){
      const dx = w*0.055, dy = h*0.07;
      return shapeMarkup(shape, px+dx, py+dy, w, h, `fill="${color}"`, 6);
    }
    function accentOverlayMarkup(accent, px, py, w, h, color){
      switch(accent){
        case 'stripe':
          return `<rect x="${px}" y="${py}" width="${w*0.16}" height="${h}" fill="${color}"/>`;
        case 'bands': {
          const bandH = h*0.15;
          return `<rect x="${px}" y="${py}" width="${w}" height="${bandH}" fill="${color}"/>
                  <rect x="${px}" y="${py+h-bandH}" width="${w}" height="${bandH}" fill="${color}"/>`;
        }
        case 'split':
          return `<polygon points="${px+w},${py} ${px+w},${py+h} ${px+w*0.35},${py+h}" fill="${color}"/>`;
        case 'banner': {
          const y0 = py+h*0.32, y1 = py+h*0.46;
          return `<path d="M ${px} ${y0+h*0.06} C ${px+w*0.3} ${y0-h*0.08}, ${px+w*0.7} ${y0+h*0.1}, ${px+w} ${y0-h*0.02}
                   L ${px+w} ${y1-h*0.02} C ${px+w*0.7} ${y1+h*0.1}, ${px+w*0.3} ${y1-h*0.08}, ${px} ${y1+h*0.06} Z"
                   fill="${color}" opacity="0.92"/>`;
        }
        default: return '';
      }
    }
    // Acrylic is the only material now, and it's always custom-colored — a
    // flat, slightly glossy fill rather than any of the old drawn textures.
    function materialFillDefs(uid, customColor){
      const c = customColor || '#C6A05F';
      return `<linearGradient id="fill-${uid}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${c}"/><stop offset="1" stop-color="${c}"/></linearGradient>`;
    }
    function shadowFilter(mounting){
      const isStandoff = mounting==='standoff';
      const dx = isStandoff?10:3, dy = isStandoff?14:4, b = isStandoff?10:3;
      return `filter:drop-shadow(${dx}px ${dy}px ${b}px rgba(0,0,0,0.45))`;
    }

    function buildChipRow(container, options, key, disableFn){
      container.innerHTML = '';
      Object.keys(options).forEach(k=>{
        const opt = options[k];
        const btn = document.createElement('button');
        btn.className = 'ss-chip';
        btn.type = 'button';
        btn.textContent = opt.label;
        if (disableFn && disableFn(k, opt)) btn.classList.add('disabled');
        if (state[key] === k) btn.classList.add('active');
        btn.addEventListener('click', ()=>{
          if (btn.classList.contains('disabled')) return;
          state[key] = k;
          render();
        });
        container.appendChild(btn);
      });
    }

    // Icons are multi-select (a sign can carry Accessible + No Smoking + Audio
    // Accessible all at once) — "None" is a clear-all action rather than a
    // normal member of the selection array.
    function buildIconChipRow(container){
      container.innerHTML = '';
      Object.keys(ICONS).forEach(k=>{
        const opt = ICONS[k];
        const btn = document.createElement('button');
        btn.className = 'ss-chip';
        btn.type = 'button';
        btn.textContent = opt.label;
        const isActive = (k==='none') ? state.icons.length===0 : state.icons.includes(k);
        if (isActive) btn.classList.add('active');
        btn.addEventListener('click', ()=>{
          if (k==='none'){
            state.icons = [];
          } else if (state.icons.includes(k)){
            state.icons = state.icons.filter(x=>x!==k);
          } else {
            state.icons = [...state.icons, k];
          }
          render();
        });
        container.appendChild(btn);
      });
    }

    // Rebuilds the rooms table only when the row count changes (add/remove/
    // paste-import) — otherwise just refreshes values on the existing inputs,
    // guarding focused fields, so typing a room number doesn't lose focus
    // every keystroke the way a full teardown-and-rebuild would.
    function buildRoomsTable(container){
      const rows = container.querySelectorAll('.ss-room-row');
      if (rows.length !== state.rooms.length){
        container.innerHTML = '';
        state.rooms.forEach((room, i)=> container.appendChild(buildRoomRow(room, i)));
        return;
      }
      state.rooms.forEach((room, i)=>{
        const row = rows[i];
        row.classList.toggle('active', i === state.activeRoomIndex);
        const numInput = row.querySelector('.ss-room-num');
        if (document.activeElement !== numInput) numInput.value = room.roomText;
        const subInput = row.querySelector('.ss-room-sub');
        if (document.activeElement !== subInput) subInput.value = room.roomSub;
        row.querySelectorAll('.ss-room-icon-toggle').forEach(btn=>{
          btn.classList.toggle('active', room.icons.includes(btn.dataset.icon));
        });
      });
    }

    function buildRoomRow(room, i){
      const row = document.createElement('div');
      row.className = 'ss-room-row' + (i===state.activeRoomIndex ? ' active' : '');

      const numInput = document.createElement('input');
      numInput.type = 'text'; numInput.className = 'ss-room-num'; numInput.maxLength = 6;
      numInput.placeholder = 'Room #'; numInput.value = room.roomText;
      numInput.addEventListener('input', e=>{ room.roomText = e.target.value; render(); });
      numInput.addEventListener('focus', ()=>{ state.activeRoomIndex = i; render(); });

      const subInput = document.createElement('input');
      subInput.type = 'text'; subInput.className = 'ss-room-sub'; subInput.maxLength = 26;
      subInput.placeholder = 'Label (optional)'; subInput.value = room.roomSub;
      subInput.addEventListener('input', e=>{ room.roomSub = e.target.value; render(); });
      subInput.addEventListener('focus', ()=>{ state.activeRoomIndex = i; render(); });

      const iconsWrap = document.createElement('div');
      iconsWrap.className = 'ss-room-icons';
      ['access','audio','nosmoking'].forEach(k=>{
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ss-room-icon-toggle' + (room.icons.includes(k) ? ' active' : '');
        btn.dataset.icon = k;
        btn.textContent = ICONS[k].label;
        btn.title = ICONS[k].label;
        btn.addEventListener('click', ()=>{
          room.icons = room.icons.includes(k) ? room.icons.filter(x=>x!==k) : [...room.icons, k];
          state.activeRoomIndex = i;
          render();
        });
        iconsWrap.appendChild(btn);
      });

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button'; removeBtn.className = 'ss-room-remove';
      removeBtn.textContent = '×'; removeBtn.setAttribute('aria-label', 'Remove room');
      removeBtn.addEventListener('click', ()=>{
        state.rooms.splice(i, 1);
        if (state.activeRoomIndex >= state.rooms.length) state.activeRoomIndex = Math.max(0, state.rooms.length-1);
        render();
      });

      row.appendChild(numInput);
      row.appendChild(subInput);
      row.appendChild(iconsWrap);
      row.appendChild(removeBtn);
      return row;
    }

    // Accepts "access", "handicap", "ada", "wheelchair" for the Handicap icon,
    // "audio"/"audio accessible" for Audio Accessible, and "no smoking" /
    // "smoke free" for No Smoking. Unrecognized tokens are just dropped
    // rather than erroring, since a bad paste shouldn't block the whole list.
    function normalizeIconToken(tok){
      const t = String(tok||'').toLowerCase().replace(/[^a-z]/g,'');
      if (['access','handicap','ada','wheelchair','accessible'].includes(t)) return 'access';
      if (['audio','audioaccessible'].includes(t)) return 'audio';
      if (['nosmoking','smokefree','nosmoke'].includes(t)) return 'nosmoking';
      return null;
    }

    // One room per line. Fields can be separated by commas or tabs (tabs so a
    // column pasted straight out of Excel/Sheets works with no reformatting):
    //   204, ADA ROOM, access+audio
    //   205
    //   206    MANAGER
    function parseBulkPaste(text){
      return String(text||'').split(/\r?\n/).map(l=>l.trim()).filter(Boolean).map(line=>{
        const fields = line.indexOf('\t') !== -1 ? line.split('\t') : line.split(',');
        const roomText = (fields[0]||'').trim();
        const roomSub = (fields[1]||'').trim();
        const iconsField = (fields[2]||'').trim();
        const icons = iconsField
          ? iconsField.split(/[+/&]/).map(normalizeIconToken).filter(Boolean)
          : [];
        return { roomText, roomSub, icons };
      }).filter(r => r.roomText);
    }

    function bindBulkControls(){
      const pasteEl = root.querySelector('#ss-bulkPaste');
      const addFromListBtn = root.querySelector('#ss-bulkAddBtn');
      const addRowBtn = root.querySelector('#ss-bulkAddRowBtn');
      const clearBtn = root.querySelector('#ss-bulkClearBtn');

      if (addFromListBtn) addFromListBtn.addEventListener('click', ()=>{
        const parsed = parseBulkPaste(pasteEl.value);
        if (!parsed.length) return;
        const startIndex = state.rooms.length;
        state.rooms = state.rooms.concat(parsed);
        state.activeRoomIndex = startIndex;
        pasteEl.value = '';
        render();
      });

      if (addRowBtn) addRowBtn.addEventListener('click', ()=>{
        state.rooms.push({ roomText:'', roomSub:'', icons:[] });
        state.activeRoomIndex = state.rooms.length - 1;
        render();
      });

      if (clearBtn) clearBtn.addEventListener('click', ()=>{
        if (!state.rooms.length) return;
        state.rooms = [];
        state.activeRoomIndex = 0;
        render();
      });
    }

    function render(){
      const shapeName = state.shape;
      if (ACCENTS[state.accent].incompatibleShapes && ACCENTS[state.accent].incompatibleShapes.includes(shapeName)){
        state.accent = 'none';
      }
      // Backplate is sold as the "Offset Shadow" accent — picking that look IS
      // the paid backplate add-on, so Material (which is what actually prices
      // the variant) tracks the accent choice rather than being picked
      // separately. This only works because there's one thickness (1/8")
      // in play; if a second thickness returns, Material needs to encode
      // both thickness and backplate again.
      state.material = (state.accent==='shadow') ? 'backplate' : 'standard';
      // Every sign we sell is ADA-compliant now — no toggle, no non-compliant
      // option. Typeface is locked to sans-serif per §703.2.2.
      if (state.typeface!=='sans'){
        state.typeface = 'sans';
      }

      const size = SIZES[state.size];
      const typeface = TYPEFACES[state.typeface];
      const plateW = 320, plateH = plateW * (size.h/size.w);
      const vbW = plateW+120, vbH = plateH+120;
      const px = (vbW-plateW)/2, py = (vbH-plateH)/2;
      const uid = state.material;
      const clipId = 'clip-' + sectionId + '-' + uid;

      let defs = materialFillDefs(uid, state.plateColor);
      const plateFill = `url(#fill-${uid})`;
      const overlay = '';
      defs += `<clipPath id="${clipId}">${shapeMarkup(shapeName, px, py, plateW, plateH, '', 6)}</clipPath>`;

      let standoffs = '';
      if (state.mounting==='standoff'){
        standoffs = standoffPoints(shapeName, px, py, plateW, plateH)
          .map(([cx,cy])=>`<circle cx="${cx}" cy="${cy}" r="5" fill="#8E7442"/><circle cx="${cx}" cy="${cy}" r="2" fill="#C6A05F"/>`).join('');
      }
      const glow = '';

      if (!state.textColorManual){
        state.textColor = MATERIALS[state.material].engrave;
      }
      const engraveColor = state.textColor;
      // Both current materials are acrylic (just different thickness), so the
      // lighter stroke always applies — revisit if a non-acrylic option is added.
      const plateStroke = 'rgba(255,255,255,0.6)';
      const plateShadow = shadowFilter(state.mounting);

      // ---- accent overlays: offset shadow draws BEHIND the plate; the rest draw
      // on top, clipped to the plate's own outline so nothing spills past the edge ----
      const accentColorValue = accentColorHex();
      const shadowBehindMarkup = state.accent==='shadow'
        ? offsetShadowMarkup(shapeName, px, py, plateW, plateH, accentColorValue) : '';
      const onTopAccentMarkup = (state.accent!=='none' && state.accent!=='shadow')
        ? accentOverlayMarkup(state.accent, px, py, plateW, plateH, accentColorValue) : '';

      const textColor = engraveColor;
      const activeRoom = getActiveRoom();

      const roomFontSize = plateH*0.34, subFontSize = plateH*0.115;
      const iconCount = activeRoom.icons.length;
      const iconSize = plateH * (iconCount > 1 ? 0.15 : 0.2);
      const iconGap = iconSize * 0.4;

      // stripe/bands accents carve out dedicated space, so keep text and the
      // icon clear of those zones rather than centering over them
      const hasStripe = state.accent==='stripe';
      const hasBands = state.accent==='bands';
      const contentLeft = px + (hasStripe ? plateW*0.16 : 0);
      const contentTop = py + (hasBands ? plateH*0.15 : 0);
      const contentBottom = py + plateH - (hasBands ? plateH*0.15 : 0);
      const cx = (contentLeft + (px+plateW)) / 2;
      const usableH = contentBottom - contentTop;

      // Real physical scale: plateW px corresponds to size.w inches, so braille
      // dots can be sized to the actual ADA-spec tolerances (§703.3) rather than
      // an arbitrary proportion of the plate — dot diameter ~0.06", dot-to-dot
      // spacing ~0.09", cell-to-cell spacing ~0.27" (mid-range of the spec).
      const pxPerInch = plateW / size.w;
      const brailleDotR = 0.0615/2 * pxPerInch;
      const brailleDotGap = 0.0925 * pxPerInch;
      const brailleCellGap = 0.2705 * pxPerInch;

      // Stack whatever's actually present (number, optional sub-label,
      // braille, optional icons) and center that whole block vertically in
      // the plate — rather than fixed top-biased fractions that assumed
      // every row was always present, which pushed the number up whenever
      // icons or a sub-label were missing.
      const hasSub = !!activeRoom.roomSub;
      const hasBraille = !!activeRoom.roomText;
      const hasIcons = iconCount>0;
      const rowGap = usableH*0.05;
      const numRowH = roomFontSize*0.82;
      const subRowH = hasSub ? subFontSize*1.3 : 0;
      const brailleRowH = hasBraille ? (brailleDotGap*2 + brailleDotR*2) : 0;
      const iconRowH = hasIcons ? iconSize : 0;
      const blockH = numRowH
        + (hasSub ? rowGap+subRowH : 0)
        + (hasBraille ? rowGap+brailleRowH : 0)
        + (hasIcons ? rowGap+iconRowH : 0);

      let cursor = contentTop + Math.max(0, (usableH-blockH)/2);
      const numY = cursor + numRowH*0.82;
      cursor += numRowH;
      let subY = 0;
      if (hasSub){ cursor += rowGap; subY = cursor + subRowH*0.7; cursor += subRowH; }
      let brailleY = 0;
      if (hasBraille){ cursor += rowGap; brailleY = cursor + brailleDotR; cursor += brailleRowH; }
      let iconCenterY = 0;
      if (hasIcons){ cursor += rowGap; iconCenterY = cursor + iconRowH/2; cursor += iconRowH; }
      const iconsTotalWidth = iconCount>0 ? iconCount*iconSize + (iconCount-1)*iconGap : 0;
      const iconsStartX = cx - iconsTotalWidth/2;
      const iconY = iconCenterY - iconSize/2;

      const iconsMarkup = activeRoom.icons.map((iconKey, i)=>{
        const ix = iconsStartX + i*(iconSize+iconGap);
        return iconImages[iconKey]
          ? `<image href="${iconImages[iconKey]}" x="${ix}" y="${iconY}" width="${iconSize}" height="${iconSize}"/>`
          : `<g transform="translate(${ix}, ${iconY}) scale(${iconSize/36})">${iconPath(iconKey, textColor)}</g>`;
      }).join('');

      const roomTextDisplay = activeRoom.roomText.toUpperCase();

      const content = `
        <text x="${cx}" y="${numY}" text-anchor="middle" font-family="${typeface.family}" font-weight="${typeface.weight}" font-style="${typeface.italic?'italic':'normal'}" font-size="${roomFontSize}" fill="${textColor}">${escapeXml(roomTextDisplay)}</text>
        ${activeRoom.roomSub ? `<text x="${cx}" y="${subY}" font-family="-apple-system,sans-serif" font-weight="500" letter-spacing="1.5" text-anchor="middle" font-size="${subFontSize}" fill="${textColor}" opacity="0.85">${escapeXml(activeRoom.roomSub.toUpperCase())}</text>` : ''}
        ${activeRoom.roomText ? brailleMarkup(activeRoom.roomText, cx, brailleY, textColor, brailleDotR, brailleDotGap, brailleCellGap) : ''}
        ${iconsMarkup}
      `;

      const svg = `
        <svg viewBox="0 0 ${vbW} ${vbH}" width="${vbW}" height="${vbH}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Room number sign preview">
          <defs>${defs}</defs>
          ${glow}
          ${shadowBehindMarkup}
          ${shapeMarkup(shapeName, px, py, plateW, plateH, `fill="${plateFill}" style="${plateShadow}" stroke="${plateStroke}" stroke-width="1"`, 6)}
          ${overlay}
          <g clip-path="url(#${clipId})">${onTopAccentMarkup}</g>
          ${standoffs}
          ${content}
        </svg>`;

      const stage = document.getElementById('ss-stage');
      let holder = stage.querySelector('.ss-svg-holder');
      if (!holder){
        holder = document.createElement('div');
        holder.className = 'ss-svg-holder';
        stage.insertBefore(holder, stage.querySelector('.ss-stage-caption'));
      }
      holder.innerHTML = svg;

      document.getElementById('ss-stage-dims').textContent = `${size.w}" × ${size.h}" — Room Number`;
      document.getElementById('ss-stage-mount').textContent = MOUNTINGS[state.mounting].label;
      const stageRoomEl = document.getElementById('ss-stage-room');
      if (stageRoomEl){
        stageRoomEl.textContent = (state.mode==='bulk' && state.rooms.length)
          ? `Previewing Room ${activeRoom.roomText || (state.activeRoomIndex+1)} of ${state.rooms.length}`
          : '';
      }

      root.querySelector('#ss-customColorFields').style.display = '';
      const textColorEl = root.querySelector('#ss-textColor');
      if (textColorEl && document.activeElement !== textColorEl) textColorEl.value = state.textColor;

      buildChipRow(root.querySelector('#ss-modeRow'), { single:{label:'Single Sign'}, bulk:{label:'Bulk Order'} }, 'mode');
      const singleSection = root.querySelector('#ss-singleSection');
      const bulkSection = root.querySelector('#ss-bulkSection');
      if (singleSection) singleSection.style.display = (state.mode==='single') ? '' : 'none';
      if (bulkSection) bulkSection.style.display = (state.mode==='bulk') ? '' : 'none';
      if (state.mode==='bulk') buildRoomsTable(root.querySelector('#ss-roomsTable'));
      const roomCountEl = root.querySelector('#ss-roomCount');
      if (roomCountEl) roomCountEl.textContent = state.rooms.length;

      buildChipRow(root.querySelector('#ss-shapeRow'), SHAPES, 'shape');
      buildChipRow(root.querySelector('#ss-typefaceRow'), TYPEFACES, 'typeface', (k)=>{
        return k!=='sans';
      });
      buildChipRow(root.querySelector('#ss-sizeRow'), SIZES, 'size');
      buildChipRow(root.querySelector('#ss-mountingRow'), MOUNTINGS, 'mounting');
      buildIconChipRow(root.querySelector('#ss-iconRow'));
      buildChipRow(root.querySelector('#ss-accentRow'), ACCENTS, 'accent', (k,opt)=>{
        return !!(opt.incompatibleShapes && opt.incompatibleShapes.includes(shapeName));
      });
      const showAccentColor = ACCENTS[state.accent].needsColor;
      root.querySelector('#ss-accentColorField').style.display = showAccentColor ? '' : 'none';
      if (showAccentColor){
        buildChipRow(root.querySelector('#ss-accentColorRow'), ACCENT_COLORS, 'accentColor');
        root.querySelector('#ss-accentCustomColorField').style.display = (state.accentColor==='custom') ? '' : 'none';
      }

      // ---- ADA compliance is now standard on every sign, so nothing about
      // it is surfaced to the customer. Contrast still gets computed here
      // (silently) rather than deleted outright, in case a low-contrast
      // flag is wanted somewhere later — it just never reaches the DOM. ----
      const contrastPass = contrastRatio(state.textColor, state.plateColor) >= 4.5;
      const complianceEl = root.querySelector('#ss-complianceCheck');
      if (complianceEl) complianceEl.style.display = 'none';

      // ---- price from the matched real Shopify variant ----
      const variant = findVariant();
      const priceEl = document.getElementById('ss-priceValue');
      const unavailableEl = document.getElementById('ss-unavailable');
      const addBtn = document.getElementById('ss-addBtn');
      const validRoomCount = state.mode==='bulk' ? state.rooms.filter(r=>r.roomText.trim()).length : 1;

      if (variant){
        if (state.mode==='bulk'){
          priceEl.textContent = validRoomCount
            ? `${variant.price} × ${validRoomCount} = ${formatTotal(variant.price, validRoomCount)}`
            : variant.price;
        } else {
          priceEl.textContent = variant.price;
        }
        if (!variant.available){
          unavailableEl.textContent = 'This combination is currently out of stock.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else if (state.mode==='bulk' && validRoomCount===0){
          unavailableEl.textContent = 'Add at least one room number to this order first.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else {
          unavailableEl.style.display = 'none';
          addBtn.disabled = false;
        }
      } else {
        priceEl.textContent = '—';
        unavailableEl.textContent = "This exact combination isn't available yet — try a different size or mounting.";
        unavailableEl.style.display = '';
        addBtn.disabled = true;
      }
      addBtn.textContent = (state.mode==='bulk') ? `Add All to Cart (${validRoomCount})` : 'Add to cart';
    }

    function formatTotal(unitPriceStr, count){
      const match = String(unitPriceStr).match(/^([^\d]*)([\d,.]+)/);
      if (!match) return unitPriceStr;
      const prefix = match[1];
      const num = parseFloat(match[2].replace(/,/g,'')) || 0;
      return prefix + (num * count).toFixed(2);
    }

    function bindTextInputs(){
      [['ss-roomText','roomText'], ['ss-roomSub','roomSub'],
       ['ss-plateColor','plateColor'],
       ['ss-accentCustomColor','accentCustomColor']].forEach(([id,key])=>{
        const el = root.querySelector('#'+id);
        if (!el) return;
        el.value = state[key];
        el.addEventListener('input', e=>{ state[key] = e.target.value; render(); });
      });
      const textColorEl = root.querySelector('#ss-textColor');
      if (textColorEl){
        textColorEl.value = state.textColor;
        textColorEl.addEventListener('input', e=>{
          state.textColor = e.target.value;
          state.textColorManual = true;
          render();
        });
      }
    }

    function buildSharedProperties(){
      const properties = {
        'Shape': SHAPES[state.shape].label,
        'Typeface': TYPEFACES[state.typeface].label
      };
      if (state.accent!=='none'){
        properties['Accent Style'] = ACCENTS[state.accent].label;
        properties['Accent Color'] = state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].label;
      }
      properties['Shape Color'] = state.plateColor;
      properties['Text Color'] = state.textColor;
      return properties;
    }

    function addToCart(){
      const variant = findVariant();
      if (!variant || !variant.available){ return; }
      const errorEl = document.getElementById('ss-error');
      const addBtn = document.getElementById('ss-addBtn');

      let items;
      if (state.mode==='bulk'){
        const validRooms = state.rooms.filter(r=>r.roomText.trim());
        if (!validRooms.length) return;
        items = validRooms.map(room=>{
          const properties = Object.assign(
            { 'Room / Text': room.roomSub ? (room.roomText + ' — ' + room.roomSub) : room.roomText,
              'Icons': room.icons.length ? room.icons.map(k=>ICONS[k].label).join(', ') : 'None' },
            buildSharedProperties()
          );
          return { id: variant.id, quantity: 1, properties: properties };
        });
      } else {
        const properties = Object.assign(
          { 'Room / Text': state.roomSub ? (state.roomText + ' — ' + state.roomSub) : state.roomText,
            'Icons': state.icons.length ? state.icons.map(k=>ICONS[k].label).join(', ') : 'None' },
          buildSharedProperties()
        );
        items = [{ id: variant.id, quantity: 1, properties: properties }];
      }

      errorEl.style.display = 'none';
      addBtn.disabled = true;
      const originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(res => res.json().then(body => ({ ok: res.ok, body })))
      .then(({ ok, body })=>{
        addBtn.disabled = false;
        if (!ok){
          errorEl.textContent = (body && body.description) || 'Could not add this to your cart. Please try again.';
          errorEl.style.display = '';
          addBtn.textContent = originalLabel;
          return;
        }
        addBtn.textContent = (state.mode==='bulk') ? `Added ${items.length} ✓` : 'Added ✓';
        addBtn.classList.add('ss-added');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: body } }));
        if (state.mode==='bulk'){
          // clear the batch after a successful add so the same rooms can't
          // accidentally get submitted twice
          state.rooms = [];
          state.activeRoomIndex = 0;
        }
        setTimeout(()=>{
          addBtn.classList.remove('ss-added');
          render();
        }, 1800);
      })
      .catch(()=>{
        addBtn.disabled = false;
        addBtn.textContent = originalLabel;
        errorEl.textContent = 'Network error — please try again.';
        errorEl.style.display = '';
      });
    }

    root.querySelector('#ss-addBtn').addEventListener('click', addToCart);

    bindTextInputs();
    bindBulkControls();
    render();
    materialImagesReady.then(render);
    iconImagesReady.then(render);
  }
})();
